export default __webpack_public_path__ + "assets/media/Top_Banner_WEB.586dfeed.webp";